import { Handshake, GraduationCap, ClipboardCheck, Megaphone, Link2, Truck } from "lucide-react";

export const CONTACT = {
  email: "contact@risqzero.com",
  phone: "+2250759126413",
  phoneDisplay: "+225 07 59 12 64 13",
  address: "Abidjan, Côte d'Ivoire",
  website: "www.risqzero.net",
  websiteUrl: "https://www.risqzero.net",
};

export const NAV = [
  { id: "impact", label: "Impact" },
  { id: "services", label: "Services" },
  { id: "evenements", label: "Événements" },
  { id: "approche", label: "Approche" },
  { id: "contact", label: "Contact" },
];

export const STATS = [
  {
    id: "deaths",
    value: 3,
    suffix: " M",
    decimals: 0,
    label: "décès liés au travail chaque année",
    source: "OIT, 2023",
    tone: "orange",
  },
  {
    id: "injuries",
    value: 395,
    suffix: " M",
    decimals: 0,
    label: "accidents du travail non mortels par an",
    source: "OIT, 2023",
    tone: "gold",
  },
  {
    id: "gdp",
    value: 4,
    suffix: " %",
    decimals: 0,
    label: "du PIB mondial perdu chaque année",
    source: "OIT",
    tone: "green",
  },
  {
    id: "seconds",
    value: 11,
    suffix: " s",
    decimals: 0,
    label: "une vie perdue toutes les 11 secondes",
    source: "Estimation OIT",
    tone: "orange",
  },
];

export const HUMAN_COST = [
  {
    title: "Des vies détruites",
    text: "Derrière chaque chiffre, une famille privée d'un revenu, un parent qui ne rentre pas, un travailleur handicapé à vie.",
    figure: "8 000",
    unit: "décès par jour",
  },
  {
    title: "Des entreprises fermées",
    text: "Selon la FEMA, 40 à 60 % des petites entreprises ne rouvrent jamais après un sinistre majeur. Un accident grave peut tout arrêter.",
    figure: "40–60 %",
    unit: "ne rouvrent jamais",
  },
  {
    title: "L'Afrique en première ligne",
    text: "Le continent affiche l'un des taux d'accidents mortels les plus élevés au monde : près de 17 décès pour 100 000 travailleurs.",
    figure: "17,4",
    unit: "décès / 100 000 travailleurs",
  },
];

export const SERVICES = [
  {
    id: "conseil",
    title: "Conseil & Stratégie HSE",
    short: "Construire une culture sécurité zéro accident, du comité de direction au terrain.",
    details: [
      "Diagnostic de maturité HSE et feuille de route",
      "Politique, objectifs et indicateurs de performance",
      "Accompagnement ISO 45001 / ISO 14001 / ISO 9001",
      "Coaching des managers et animateurs sécurité",
    ],
    icon: Handshake,
    span: "lg:col-span-2",
  },
  {
    id: "formation",
    title: "Formation",
    short: "Modules pratiques et certifiants pour équipes terrain, encadrement et direction.",
    details: [
      "Secourisme, incendie, travail en hauteur, habilitations",
      "Analyse des risques et causes racines",
      "Leadership sécurité et culture juste",
      "Formations in situ, bilingues, adaptées au contexte africain",
    ],
    icon: GraduationCap,
    span: "",
  },
  {
    id: "audit",
    title: "Audit & Diagnostic",
    short: "Mesurer la conformité réglementaire et révéler les risques avant qu'ils ne frappent.",
    details: [
      "Audit réglementaire et documentaire",
      "Inspection terrain et observation des comportements",
      "Évaluation des risques professionnels (DUERP)",
      "Rapport d'audit priorisé et plan d'action",
    ],
    icon: ClipboardCheck,
    span: "",
  },
  {
    id: "evenement",
    title: "Événements & Sensibilisation",
    short: "Safety Days, ateliers et campagnes qui marquent les esprits et changent les comportements.",
    details: [
      "Journées sécurité clé en main",
      "Ateliers immersifs et théâtre-forum",
      "Campagnes d'affichage et contenus pédagogiques",
      "Conférences et tables rondes HSE",
    ],
    icon: Megaphone,
    span: "lg:col-span-2",
  },
  {
    id: "mise-en-relation",
    title: "Mise en relation",
    short: "Un réseau d'experts HSE qualifiés en Afrique, mobilisables rapidement.",
    details: [
      "Consultants spécialisés par secteur (mines, BTP, industrie, agro)",
      "Médecins du travail et ergonomes partenaires",
      "Laboratoires et organismes de contrôle",
      "Cabinets de certification accrédités",
    ],
    icon: Link2,
    span: "lg:col-span-2",
  },
  {
    id: "distribution",
    title: "Distribution d'EPI",
    short: "Équipements de protection individuelle certifiés, livrés là où vos équipes travaillent.",
    details: [
      "Casques, gants, chaussures et protections auditives certifiés",
      "Signalétique et équipements de premiers secours",
      "Dotation personnalisée et suivi des stocks",
      "Logistique vers les sites isolés",
    ],
    icon: Truck,
    span: "",
  },
];

export const MARQUEE = [
  "Zéro accident",
  "Santé & sécurité au travail",
  "Expertise HSE en Afrique",
  "Impact durable",
  "Prévenir & protéger",
  "De la Qualité à Zéro accident",
];
